<template>
	<div class="top20">
		<el-dialog :title="title" :visible.sync="show" width="30%" :before-close="close" :close-on-click-modal="false"
		 :modal-append-to-body="false">
			<el-form ref="form" :model="form" :inline="true" label-width="80px">
				<el-form-item label="部门名称" prop="name" :rules="[{required:true,message:'请输入部门名称'}]">
					<el-input v-model="form.name" style="width: 175px;" placeholder="部门名称"></el-input>
				</el-form-item>
				<el-form-item label="部门序号">
					<el-input-number v-model="form.sort" :min="0" style="width: 175px;"></el-input-number>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" @click="ok">确 定</el-button>
			</span>
		</el-dialog>
		<div class="text-right padding12">
			<el-button type="primary" @click="addRow({id:0})">新增顶级部门</el-button>
		</div>
		<el-table :data="data" style="width: 100%;" row-key="id" border :default-expand-all="false">
			<el-table-column prop="name" label="部门"></el-table-column>
			<el-table-column prop="sort" label="序号"></el-table-column>
			<el-table-column prop="createTime" label="创建时间">
				<template slot-scope="{row}">{{setTime(row.createTime)}}</template>
			</el-table-column>
			<el-table-column label="编辑">
				<template slot-scope="{row}">
					<el-button type="text" @click="addRow(row)">新增</el-button>
					<el-button type="text" @click="setRow(row)">编辑</el-button>
					<el-button type="text" @click="delRow(row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination class="top10" background layout="total, prev, pager, next,jumper" :page-size="size" :total="totalNum" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: [], //表格数据
				obj: "", //当前行
				page: 1, //当前页
				size: 10000, //页大小
				name: "", //模糊查询名字
				totalNum: 0, //总页数
				title: "新增", //弹框标题
				show: false, //控制弹框显示隐藏
				form: { //表单数据
					name: "",
					sort: 0,
				},
				oldForm: "", //form备份
			}
		},
		methods: {
			close() { //弹窗关闭
				this.show = false
				this.$refs.form.resetFields()
			},
			getAll() { //获取表格数据
				this.$http.post(`/api/dept/findDept`, {
					name: this.name,
					currentPage: this.page,
					pageSize: this.size
				}).then(res => {
					let data = res.data.data.items;
					let parents = data.filter(item => item.pid == 0) //顶级
					let children = data.filter(item => item.pid != 0) //子类
					let translator = (parents, children) => { //处理成树形数据
						parents.forEach((parent) => { //循环顶级
							children.forEach((current, index) => { //循环子类
								if (current.pid === parent.id) { //父id=子id
									let temp = JSON.parse(JSON.stringify(children))
									temp.splice(index, 1)
									translator([current], temp)
									typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current]
								}
							})
						})
					}
					translator(parents, children)
					this.data = parents
					this.totalNum = parents.length
				})
			},
			addRow(obj) { // 点击新增
				this.obj = obj;
				obj.id ? this.title = `新增(${obj.name})下级部门` : this.title = "新增顶级部门"
				this.form = { ...this.oldForm,
					pid: obj.id
				}
				this.show = true;
			},
			setRow(obj) { //点击修改
				this.title = "修改";
				this.form = { ...obj
				}
				this.show = true
			},
			ok() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						let url = `/api/dept/editDept`;
						if (this.title[0] == "新") {
							url = `/api/dept/addDept`
						}
						this.$http.post(url, this.form).then(res => {
							this.$message.success(res.data.message)
							this.close()
							this.getAll()
						})
					} else {
						this.$message.warning("请完善信息")
						return false;
					}
				});
			},
			delRow(obj) { // 删除
				this.$confirm('确定删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/dept/deleteDept`, {
						ids: [obj.id]
					}).then(res => {
						this.$message.success(res.data.message)
						this.getAll()
					})
				}).catch(() => {});
			},
		},
		created() {
			this.getAll()
			this.oldForm = JSON.parse(JSON.stringify(this.form))
		}
	}
</script>

<style scoped="scoped"></style>
